"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMapPage = exports.TagMapPageConfig = exports.Style = exports.CSS = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const icons_1 = require("../components/icon/icons");
const theme_1 = require("../components/theme");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const collection_view_1 = require("../modules/collection.view/collection.view");
const collection_view_ctrl_1 = require("../modules/collection.view/collection.view.ctrl");
const collection_view_style_1 = require("../modules/collection.view/collection.view.style");
const tag_list_1 = require("../modules/tag.list/tag.list");
const tag_list_style_1 = require("../modules/tag.list/tag.list.style");
const bounding_string_1 = require("../modules/tag.map/bounding.string");
const tag_map_1 = require("../modules/tag.map/tag.map");
const services_1 = require("../services");
const page_state_1 = require("../state/page.state");
const store_1 = require("../store");
const browser_check_1 = require("../util/browser-check");
const page_1 = require("./page");
const tag_state_1 = require("./tag.state");
exports.CSS = {
    container: 'c-TagView',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        height: '100%',
        'min-width': '1000px',
        [`& .${tag_list_style_1.CSS.container}`]: {
            width: '20%',
            'min-width': '350px',
        },
        [`& .${collection_view_style_1.CSS.container}`]: {
            width: '20%',
            'min-width': '420px',
        },
    },
};
(0, theme_1.addStyles)(exports.Style);
exports.TagMapPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.map,
    path: ['/map', '/map/:location'],
    auth: {
        required: true,
    },
    nav: {
        name: i18n_1.T.LIST_MAP,
        icon: icons_1.MaterialIcon.MAP,
    },
    layout: { nav: false },
    supportDepartmentChange: true,
};
class TagMapPage extends page_1.IkePage {
    constructor() {
        super(exports.TagMapPageConfig);
        this.rendered = false;
        this.browserCheck = new browser_check_1.BrowserCheck();
    }
    init() {
        // TODO: Move this into routing logic
        store_1.AppStore.TagSummary.clear();
        services_1.Services.Search.reset();
        const refreshTagPromise = store_1.AppStore.Tag.refresh();
        page_state_1.CurrentState.reset();
        this.state = new tag_state_1.TagState();
        this.tagList = new tag_list_1.TagList(this.state);
        this.tagMap = new tag_map_1.TagMap(this.state);
        this.editCtrl = new collection_view_ctrl_1.CollectionEditCtrl(this.state.map);
        this.collectionView = new collection_view_1.CollectionEdit(this.editCtrl);
        Promise.resolve()
            .then(() => refreshTagPromise)
            .then(() => this.syncInspectedCollection())
            .then(() => this.syncSearchFilter())
            .catch((e) => services_1.Logger.error(e));
        this.reaction(() => services_1.Services.Search.filterState.filter, (value) => {
            services_1.Services.Route.setParam('f', value);
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Filter', value, 1);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME });
        this.reaction(() => page_state_1.CurrentState.inspectedCollectionRevision, (revision) => {
            const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary == null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.state.map.zoomToCollection(collectionSummary.revision);
            services_1.Services.Route.setParam('t', page_state_1.CurrentState.inspectedTagId);
            services_1.Services.Route.setParam('collection', collectionSummary.uuid);
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Inspect:Collection', collectionSummary.uuid, 1);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME });
        // Watch the bounds and update the location
        this.reaction((_) => {
            return {
                center: this.state.map.bounds && this.state.map.bounds.getCenter().toJSON(),
                zoom: this.state.map.zoom,
            };
        }, (args) => {
            const boundingString = bounding_string_1.BoundingString.toString(args.center, args.zoom);
            if (boundingString === '') {
                return;
            }
            services_1.Services.Route.setParam('location', boundingString);
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Bounds', boundingString, 1);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME });
        this.eventContext = services_1.Services.Input.getContext();
        this.eventContext.on(this.eventContext.Code.KeyS, this.saveCollection, {
            modifiers: {
                ctrl: true,
            },
        });
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE) ||
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_CTRL_SHIFT_SELECT)) {
            if (this.browserCheck.os === 'Mac OS') {
                // macos
                this.registerCtrlShiftPressed('keydown', true, { meta: true, shift: true });
                this.registerCtrlShiftPressed('keyup', false, { meta: true });
            }
            // windows
            this.registerCtrlShiftPressed('keydown', true, { ctrl: true, shift: true });
            this.registerCtrlShiftPressed('keyup', false, { ctrl: true });
            // common
            this.registerCtrlShiftPressed('keyup', false, { shift: true });
        }
        this.rendered = true;
    }
    get nodes() {
        if (!services_1.Services.Map.isReady) {
            return null;
        }
        if (services_1.Services.Department.current == null) {
            store_1.AppStore.TagSummary.clear();
            return null;
        }
        if (this.rendered === false) {
            this.init();
        }
        const showInspectedCollection = page_state_1.CurrentState.inspectedCollectionRevision != null;
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, [
            this.tagList.view(),
            this.tagMap.view(),
            showInspectedCollection ? this.collectionView.view() : null,
        ]);
    }
    onRemove() {
        super.onRemove();
        if (this.state != null) {
            this.state.destroy();
        }
        if (this.eventContext) {
            this.eventContext.destroy();
        }
        if (this.editCtrl) {
            this.editCtrl.destroy();
        }
    }
    syncSearchFilter() {
        if (services_1.Services.Route.params.get('f') != null) {
            services_1.Services.Search.inputfilterState.setFilter(services_1.Services.Route.params.get('f'));
            return;
        }
        const filter = services_1.Services.Search.inputfilterState.filter;
        if (filter != null) {
            services_1.Services.Route.setParam('f', filter);
        }
    }
    saveCollection(evt) {
        if (this.editCtrl.collection == null) {
            return;
        }
        evt.event.preventDefault();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.editCtrl.saveChanges(evt.event);
    }
    syncInspectedCollection() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const tagId = services_1.Services.Route.params.get('t');
            const collectionUUID = services_1.Services.Route.params.get('collection');
            if (tagId == null || collectionUUID == null) {
                return Promise.resolve();
            }
            yield store_1.AppStore.Tag.fetch(tagId);
            const tagSummary = yield store_1.AppStore.TagSummary.getFetchable(tagId).fetch();
            if (tagSummary == null) {
                page_state_1.CurrentState.setInspectedCollectionFailed();
                return null;
            }
            const promises = tagSummary.revisions.map((revision) => store_1.AppStore.CollectionSummary.fetch(revision));
            const collectionSummaries = yield Promise.all(promises);
            if (collectionSummaries == null) {
                return;
            }
            const targetCollectionSummary = collectionSummaries.find((c) => c.uuid === collectionUUID);
            if (targetCollectionSummary == null) {
                page_state_1.CurrentState.setInspectedCollectionFailed();
                return;
            }
            page_state_1.CurrentState.setInspectedCollection(targetCollectionSummary.revision);
        });
    }
    registerCtrlShiftPressed(eventType, isPressed, modifiers) {
        this.eventContext.on(this.eventContext.Code.AllKeys, () => {
            page_state_1.CurrentState.setIsCtrlShiftPressed(isPressed);
        }, {
            eventType,
            modifiers,
        });
    }
}
exports.TagMapPage = TagMapPage;
tslib_1.__decorate([
    mobx_1.action
], TagMapPage.prototype, "syncSearchFilter", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TagMapPage.prototype, "saveCollection", null);
//# sourceMappingURL=tag.map.page.js.map